import {
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Modal,
    OutlinedInput,
    Select, TextField,
    Typography
} from "@mui/material";
import {useState} from "react";
import {OverlayScrollbarsComponent} from "overlayscrollbars-react";

export default function SettingsMenu(props) {
    const {
        open,
        onClose,
        mobile
    } = props;

    const [locale, setLocale] = useState(localStorage.getItem('tm-locale') || 'en-gb');
    const [timezoneOffset, setTimezoneOffset] = useState(localStorage.getItem('tm-offset') || '-5');

    const save = () => {
        if (['en', 'en-gb'].includes(locale)) {
            localStorage.setItem('tm-locale', locale);
        }

        try {
            const offset = parseInt(timezoneOffset);
            localStorage.setItem('tm-offset', `${offset}`);
        } catch (e) {}

        window.location.reload();
    }

    return (
        <>
            <Modal
               open={open}
               onClose={onClose}
            >
                <div>
                    <OverlayScrollbarsComponent
                        options={{
                            scrollbars: {
                                theme: 'os-theme-light'
                            }
                        }}
                        style={{
                            padding: '4rem',
                            position: 'absolute',
                            top: mobile ? '0' : '50%',
                            left: mobile ? '0' : '50%',
                            transform: !mobile && 'translate(-50%, -50%)',
                            width: mobile ? '100vw' : '700px',
                            maxHeight: mobile ? '100vh' : 'calc(100% - 100px)',
                            height: mobile && '100vh',
                            bgcolor: 'background.paper',
                            boxShadow: '24rem',
                            borderRadius: '5px',
                            overflowY: 'hidden',
                            background: 'rgb(18, 18, 18)',
                        }}
                    >
                        <Typography
                            variant="h1"
                            component="h1"
                            mb="30px"
                            fontSize="18pt"
                            fontWeight="400"
                        >
                            Settings
                        </Typography>

                        <FormControl
                            sx={{
                                mb: '20px',
                            }}
                            fullWidth
                        >
                            <InputLabel>Time Format / Locale</InputLabel>
                            <Select
                                variant="outlined"
                                input={<OutlinedInput label="Time Format / Locale" />}
                                value={locale}
                                onChange={(e) => setLocale(e.target.value)}
                            >
                                <MenuItem
                                    value="en"
                                >
                                    American (en)
                                </MenuItem>
                                <MenuItem
                                    value="en-gb"
                                >
                                    European (en-gb)
                                </MenuItem>
                            </Select>
                        </FormControl>

                        <TextField
                            label="Timezone Offset (from UTC)"
                            value={timezoneOffset}
                            onChange={(e) => setTimezoneOffset(e.target.value)}
                            sx={{
                                mb: '20px',
                            }}
                            fullWidth
                        />

                        <Button
                            variant="contained"
                            sx={{
                                mr: '10px',
                                mt: '30px',
                            }}
                            onClick={save}
                        >
                            Save
                        </Button>

                        <Button
                            onClick={onClose}
                            sx={{
                                mt: '30px',
                            }}
                        >
                            Cancel
                        </Button>
                    </OverlayScrollbarsComponent>
                </div>
            </Modal>
        </>
    );
}